<template>
  <div class="tree-container">
    <div
      v-for="s in 3"
      :key="s"
      class="row justify-content-center no-gutters"
    >
      <div
        v-for="b in grouppedByStar[s]"
        :key="b.id"
        class="badge-icon text-center px-1 py-3"
        style="min-width: 60px"
      >
        <img
          :ref="`badge${b.id}`"
          :src="b.icon"
        >
      </div>
    </div>

    <svg
      ref="canvas"
      style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"
    >
      <line
        v-for="(e, index) in edges"
        :key="index"
        v-bind="e"
        stroke="rgba(100,100,100,0.7)"
        stroke-width="2"
      />
    </svg>
  </div>
</template>

<script>

const sortGraph = (edges, conn, num) => {
  let order = {};
  let last = num;

  conn.forEach((c) => {
    last += 1;
    order[c] = last;

    const next = edges
      .filter((x) => x.from === c)
      .map((x) => x.to);

    const res = sortGraph(edges, next, last);
    order = { ...order, ...res.order };
    last = res.last;
  });

  return {
    order,
    last,
  };
};

export default {
  props: {
    badges: Array,
  },
  data: () => ({
    positions: null,
    box: {},
  }),
  computed: {
    connections() {
      return this.badges
        .flatMap((b) => {
          if (!b.basedOn || b.stars === 1) return [];
          if (!Array.isArray(b.basedOn)) {
            return [{
              from: b.basedOn,
              to: b.id,
            }];
          }

          return b.basedOn.map((x) => ({
            from: x,
            to: b.id,
          }));
        });
    },
    edges() {
      if (!this.positions || !this.$refs.canvas) return [];
      const { canvas } = this.$refs;
      const svgBox = canvas.getBoundingClientRect();

      return this.connections
        .map(({ from, to }) => ({
          from: this.positions[from],
          to: this.positions[to],
        }))
        .filter(({ from, to }) => from && to)
        .map(({ from, to }) => ({
          x1: (from.left - svgBox.left) + (from.width / 2),
          y1: (from.top - svgBox.top) + from.height + 5,
          x2: (to.left - svgBox.left) + (from.width / 2),
          y2: (to.top - svgBox.top) - 5,
        }));
    },
    grouppedByStar() {
      const first = this.badges.filter((x) => x.stars === 1).map((x) => x.id);
      const { order } = sortGraph(this.connections, first, 0);

      return this.badges
        .slice()
        .sort((a, b) => order[b.id] - order[a.id])
        .reduce((acc, curr) => {
          acc[curr.stars].push(curr);
          return acc;
        }, { 1: [], 2: [], 3: [] });
    },
  },
  watch: {
    badges() {
      this.$nextTick(() => {
        this.redraw();
      });
    },
  },
  methods: {
    redraw() {
      this.positions = this.badges.map((b) => {
        const refs = this.$refs[`badge${b.id}`];
        if (!refs || refs.length === 0) return null;
        return { id: b.id, box: refs[0].getBoundingClientRect() };
      })
        .filter((e) => e)
        .reduce((acc, curr) => {
          acc[curr.id] = curr.box;
          return acc;
        }, {});
    },
  },
  mounted() {
    this.$nextTick(() => {
      setInterval(() => {
        this.redraw();
      }, 1000);
    });
  },
};
</script>

<style lang="scss" scoped>
  .badge-icon {
    img {
      max-width: 60px;
    }
  }

  .tree-container {
    position: relative;
  }
</style>
